export class CookieConsentComponent {
    cookieConsent!: string;

    hasConsent!: boolean;

    $onInit() {
        this.updateCookiebotConsent();

        if (!this.getCookiebot()) {
            console.warn('Cookiebot not found');
        }

        window.addEventListener('CookiebotOnAccept', (evt) => {
            this.updateCookiebotConsent();
        });
    }

    updateCookiebotConsent() {
        // cookiebot is enabled only on prod - default to true
        if (!this.getCookiebot()) {
            this.hasConsent = true;
            return;
        }

        this.hasConsent = this.getCookiebot()?.consent[this.cookieConsent];
    }

    getCookiebot(): any {
        return (window as any).Cookiebot;
    }
}

angular.module('tradersyard').component('tyCookieConsentComponent', {
    // language=HTML
    template: `
        <ng-transclude ng-if="$ctrl.hasConsent"></ng-transclude>
    `,
    controller: CookieConsentComponent,
    transclude: true,
    bindings: {
        cookieConsent: '@',
    },
});
